<template>
  <v-container fluid>
    <h1 class="display-inline">Forecast: Sales Pipeline</h1>
    <div class="display-inline ml-3">
      <ActiveApiCalls/>
    </div>
    <p>The current state of the leads pipeline</p>
    <LeadsDashboard/>
    <LeadsKpiGraphs/>
  </v-container>
</template>

<script>

import LeadsDashboard from "@/components/leads/LeadsDashboard.vue"
import LeadsKpiGraphs from "@/components/leads/LeadsKpiGraphs.vue"
import ActiveApiCalls from "@/components/tools/ActiveApiCalls.vue";

export default {
  name: "ReportKPIPage",
  permissions: [...LeadsKpiGraphs.permissions, ...LeadsDashboard.permissions],
  components: { ActiveApiCalls, LeadsKpiGraphs, LeadsDashboard},
  data() {
    return {}
  },
  mounted() {

  },
}

</script>

<style scoped>

</style>